// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB6y7jTfcJen_zP7kI6Amfs512P4q1wTlQ",
  authDomain: "kuzapoints.firebaseapp.com",
  projectId: "kuzapoints",
  storageBucket: "kuzapoints.firebasestorage.app",
  messagingSenderId: "646155131360",
  appId: "1:646155131360:web:40bfd76f5085369ea37385",
  measurementId: "G-4SR6EJDT3B"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export {app};
export {analytics}